import { Box, Typography, portalChrome } from '@glplus/glpweb-dsl';
import { useTranslation } from 'react-i18next';

const CHROME = portalChrome.driver;
const PUBLIC_SITE = (import.meta.env.VITE_PUBLIC_SITE_URL as string | undefined) ?? 'https://www.grocerylistplus.com';

const LINK = { color: 'inherit', textDecoration: 'underline' } as const;

/**
 * Deck §1/§4 footer: navy, © left, "Runner Terms · Privacy · Support" right.
 * "GL Plus Dispatch" was removed from the footer (Rod, 2026-09-19).
 *
 * 🔒 Rod, 2026-09-19: the Runner Terms and the Runner Privacy Notice are linked
 * from the footer of EVERY Runner page. This footer is mounted by AppShell (all
 * signed-in routes) and by Login, so that is every page the portal has. Both
 * public Runner reader routes show the versioned content hosted on the public
 * site. A Terms bump is a web deploy and requires no native build.
 */
export default function MainFooter() {
  const { t } = useTranslation();
  return (
    <Box component="footer" data-testid="app-footer" sx={{ backgroundColor: CHROME.footerBg ?? '#343F5B', color: CHROME.footerText, px: { xs: '16px', sm: '32px', lg: '40px' }, py: 1.5, display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '12px', flexWrap: 'wrap', gap: 1 }}>
      <Typography data-testid="footer-copyright" sx={{ fontSize: '12px', color: 'inherit' }}>© {new Date().getFullYear()} Grocery List Plus, Inc.</Typography>
      <Typography sx={{ fontSize: '12px', color: 'inherit' }}>
        <Box component="a" href="/legal/terms" data-testid="footer-link-terms" sx={LINK}>
          {t('footer.terms')}
        </Box>
        {' · '}
        <Box component="a" href="/legal/privacy" data-testid="footer-link-privacy" sx={LINK}>
          {t('footer.privacy')}
        </Box>
        {' · '}
        <Box component="a" href={`${PUBLIC_SITE}/contact?topic=drive`} data-testid="footer-link-support" sx={LINK}>
          {t('footer.support')}
        </Box>
      </Typography>
    </Box>
  );
}
